import { getHealthCheckStatsThunk } from '../../thunk/healthCheck';

export default {
    [getHealthCheckStatsThunk.pending as any]: (state) => {
        state.status = 'loading';
        state.error = null;
    },
    [getHealthCheckStatsThunk.fulfilled as any]: (state, action) => {
        state.status = 'resolved';
        state.data = action.payload;
        state.queryParams = { ...action.meta.arg };
    },
    [getHealthCheckStatsThunk.rejected as any]: (state, action) => {
        state.status = 'rejected';
        state.error = action.payload;
    }
}; 